import { AxiosResponse } from "axios";
import axiosInstance from "./axiosInstance";


export const getFilters = () => {
  return axiosInstance.get("/filters").then((result) => {
    return result.data.data; //returns filters array
  });
};

export const deleteKeyword = (
  keyword_id: number
): Promise<AxiosResponse<any>> => {
  return axiosInstance
    .delete("/filters/delete-keyword", {
      data: {keyword_id: keyword_id}
    })
    .then((result) => {
      return result.data;
    });
};

export const updateKeywords = (
  keywordCategory: System.keywordCategory
): Promise<AxiosResponse<any>> => {
  return axiosInstance
    .post("/filters/update-keywords", {
      keywords: keywordCategory,
    })
    .then((result) => {
      return result.data;
    });
};

export const insertNewKeywordCategory = (keywordName: string) : Promise<AxiosResponse<any>> => {
  return axiosInstance
    .post("/filters/new-keyword-category", {
      keywordCategoryName: keywordName,
    })
    .then((result) => {
      return result.data;
    });
};

export const insertNewKeyword = (keywordName: string, keywordCategoryID: number) : Promise<AxiosResponse<any>> => {
  return axiosInstance
    .post("/filters/new-keyword", {
      keywordName: keywordName,
      keywordCategoryID: keywordCategoryID
    })
    .then((result) => {
      return result.data;
    });
};